<template>
    <div v-if="!!event && uris.length > 0" class="form-group hg-share">
        <label><span v-i18n="'SHARE_WITH'"/></label>
        <div class="hg-share-carousel">
            <div v-for="uri in uris" :key="uri.type">
                <a  :href="uri.url" 
                    target="_blank" 
                    class="btn btn-secondary" 
                    :style="uri.style" 
                    :title="uri.title | i18n">
                    <font-awesome-icon :icon="uri.icon" />
                </a>
            </div>
        </div>
        <b-input-group class="hg-share-clipboard" >
            <b-form-input   id="grp-url" class="hg-input" 
                            :value="$hisport.getEventLink(event)"
                            disabled />
            <b-input-group-append>
            <b-button   @click="copyClipboard" 
                        v-promise-btn
                        v-i18n="'COPY_CLIPBOARD'"></b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>
<script>
export default {
    props: {
        event: {type: Object}
    },
    methods: {
        copyClipboard(){
            var url = this.$hisport.getEventLink(this.event);
            return this.$hisport.options.helpers.toClipboard(url)
        }
    },
    computed: {
        uris(){
            var self = this;
            return this.$hisport.getEventShares(this.event)
                .filter(function(uri){ return !Array.isArray(uri.visibilities) || uri.visibilities.indexOf(self.event.visibility)>=0});
        }
    }
}
</script>
<style scoped>
.hg-share-carousel{
    display:flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-items: flex-start;
}
.hg-share-carousel>div{
    margin:5px;
}
.hg-share-carousel>div>a{
    border-radius:50%!important;
    border:rgba(255,255,255,.1)
}
.hg-share-clipboard{
    margin-top:20px;
}
.hg-share-clipboard button{
    color:var(--hg-red);
    text-transform: uppercase;
    font-weight:bold;
    background:#FFFFFF;
}
</style>